import { handleActions } from "redux-actions";

const initState = {
  currentUser: null,
  isFetchingCurrentUser: false,
  fetchingCurrentUserFailed: false,
  fetchingCurrentUserError: null,
  isFetchingUsers: false,
  users: null,
  isCreatingUser: false,
  isCreatedUser: false,
  fetchingCreateUserFailed: false,
  fetchingCreateUserError: null,
  isUpdatingUsers: false,
  isUpdatedUsers: false,
  fetchingUpdateUserFailed: false,
  fetchingUpdateUserError: null,
  isDeletingUser: false,
  isDeletedUser: false,
};

const reducer = handleActions(
  {
    // GET Current Users Actions
    REQUESTED_CURRENT_USER: (state) => ({
      ...state,
      currentUser: null,
      isFetchingCurrentUser: true,
      fetchingCurrentUserFailed: false,
      fetchingCurrentUserError: null,
    }),
    RECEIVED_CURRENT_USER: (state, action) => {
      const newState = {
        ...state,
        isFetchingCurrentUser: false,
        currentUser: action.payload.currentUser,
      };
      return newState;
    },
    REQUESTED_CURRENT_USER_FAILED: (state, action) => {
      const newState = {
        ...state,
        fetchingCurrentUserFailed: true,
        fetchingCurrentUserError: action.payload && action.payload.error,
      };
      return newState;
    },

    // GET Users Actions
    REQUESTED_USERS: (state) => ({
      ...state,
      isFetchingUsers: true,
    }),
    RECEIVED_USERS: (state, action) => {
      const newState = {
        ...state,
      };
      newState.isFetchingUsers = false;
      newState.isDeletedUser = false;
      newState.isCreatedUser = false;
      newState.isUpdatedUsers = false;
      newState.users =
        action.payload.users &&
        action.payload.users.reduce((obj, item) => {
          item.user_products = "";
          item.role = "";
          if (item.products) {
            item.products.forEach((product) => {
              if (item.user_products) {
                item.user_products += "; " + product.name;
              } else {
                item.user_products += product.name;
              }
            });
          }
          if (item.roles) {
            item.roles.forEach((role) => {
              if (role.name === "admin") {
                item.role = "admin";
                item.manage_user = "Yes";
                item.manage_product = "Yes";
                item.user_products = "All Products";
              }
              if (role.name === "product_manage") {
                item.manage_product = "Yes";
                item.user_products = "All Products";
                item.role = item.role ? item.role : "product_manage";
              }
            });
          }
          if (item.role === "") {
            item.role = "product_edit";
          }
          if (item.user_products === "") {
            item.user_products = "None";
          }
          item.isFetchingProduct = false;
          obj.push(item);
          return obj;
        }, []);
      return newState;
    },
    REQUESTED_USER_BY_ID: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.users) {
        newState.users[action.payload.name] = {
          isFetchingUser: true,
          name: action.payload.name,
        };
      }
      return newState;
    },
    RECEIVED_USER_BY_ID: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.users) {
        newState.users[action.payload.user.name] = {
          ...action.payload.user,
          isFetchingUser: false,
        };
      }
      return newState;
    },

    // Create User Actions
    REQUESTED_CREATE_USER: (state) => ({
      ...state,
      isCreatingUser: true,
      isCreatedUser: false,
      fetchingCreateUserFailed: false,
      fetchingCreateUserError: null,
    }),
    RECEIVED_CREATE_USER: (state, action) => {
      const newState = {
        ...state,
        isCreatingUser: false,
        isCreatedUser: true,
      };
      return newState;
    },
    REQUESTED_CREATE_USER_FAILED: (state, action) => {
      const newState = {
        ...state,
        fetchingCreateUserFailed: true,
        fetchingCreateUserError: action.payload && action.payload.error,
      };
      return newState;
    },
    REQUESTED_CLEAR_FAILED_MSG: (state, action) => {
      const newState = {
        ...state,
        isCreatingUser: false,
        isCreatedUser: false,
        fetchingCreateUserFailed: false,
        fetchingCreateUserError: null,
        fetchingUpdateUserFailed: false,
        fetchingUpdateUserError: null,
        isUpdatingUsers: false,
        isUpdatedUsers: false,
      };
      return newState;
    },

    // Delete User Actions
    REQUESTED_DELETE_USER: (state) => ({
      ...state,
      isDeletingUser: true,
      isDeletedUser: false,
    }),
    RECEIVED_DELETE_USER: (state, action) => {
      const newState = {
        ...state,
        isDeletingUser: false,
        isDeletedUser: true,
      };
      return newState;
    },

    // Update User Actions
    REQUESTED_UPDATE_USER: (state) => ({
      ...state,
      isUpdatingUsers: true,
      isUpdatedUsers: false,
      fetchingUpdateUserFailed: false,
      fetchingUpdateUserError: null,
    }),
    RECEIVED_UPDATE_USER: (state, action) => {
      const newState = {
        ...state,
        isUpdatingUsers: false,
        isUpdatedUsers: true,
      };
      return newState;
    },
    REQUESTED_UPDATE_USER_FAILED: (state, action) => {
      const newState = {
        ...state,
        fetchingUpdateUserFailed: true,
        fetchingUpdateUserError: action.payload && action.payload.error,
      };
      return newState;
    },
  },
  initState
);

export default reducer;
